import React from 'react';
import { getTrackName } from '@jbrowse/core/util/tracks';
import { getSession } from '@jbrowse/core/util';
import SVGRegionSeparators from './SVGRegionSeparators';
import SVGTrackLabel from './SVGTrackLabel';
// SVG component, tracks
export default function SVGTracks({ displayResults, model, offset, textHeight, fontSize, trackLabels = 'offset', trackLabelOffset = 0, }) {
    const session = getSession(model);
    const textOffset = trackLabels === 'offset' ? textHeight : 0;
    return (React.createElement(React.Fragment, null, displayResults.map(({ track, result }) => {
        const current = offset;
        const conf = track.configuration;
        const trackName = getTrackName(conf, session);
        const display = track.displays[0];
        const x = Math.max(-model.offsetPx, 0);
        offset += display.height + textOffset;
        return (React.createElement("g", { key: conf.trackId, transform: `translate(0 ${current})` },
            React.createElement("g", { transform: `translate(${trackLabelOffset} ${textOffset})` },
                React.createElement(SVGRegionSeparators, { model: model, height: display.height }),
                result),
            React.createElement(SVGTrackLabel, { trackName: trackName, fontSize: fontSize, trackLabels: trackLabels, trackLabelOffset: trackLabelOffset, x: x })));
    })));
}
